/*global
    jQuery
*/
(function($){
    // mobile main nav

    'use strict';

    var $toggler = $('.nav-toggler'),
        $toggle = $('.links').find('li');

    $toggler.on('click', function () {

        var $this = $(this);
        $this.siblings('ul').toggleClass('is-open');

    });

    $('.nav-menu-item').on('click', function () {

        $('.nav-submenu').removeClass('is-open');
        $(this).find('.nav-submenu').toggleClass('is-open');

    });

    // mobile footer nav
    $toggle.on('click', function () {

        $toggle.find('ul').removeClass('is-open');
        $(this).find('ul').toggleClass('is-open');

    });
}(jQuery));
